import { Document } from '@contentful/rich-text-types'
import { IProps as IImage } from '../../elements/Image'
import { LegacyColor } from '../../utils/constants/colors-legacy'
import { Color } from '../../utils/constants/colors'
import { Carousel as CarouselComponent } from './component-legacy'
import { mq, withMediaQuery } from '../../utils'
import { ICtaLink } from 'marketing-site/@types/generated/contentful'

export const Carousel = withMediaQuery(
  // @ts-ignore
  'isMobile',
  mq.mobile,
  CarouselComponent,
)

export interface IProps {
  headline?: string
  isMobile?: boolean
  slides: ISlideProps[]
  bgColor?: 'White' | 'LightGray'
  eyebrow?: string
  subheading?: string
  ctaLink?: ICtaLink
  footerText?: string
  slidesPosition?: 'Top' | 'Bottom'
  firstSlide?: number
}

export interface ISlideProps {
  id: string
  image: IImage
  imageWidth?: number
  backgroundColor?: LegacyColor | Color
  description?: Document | null
  video?: string
}
